<template>
  <div>
    <div class="alert alert-info">
      Kolom isian dengan tanda bintang (<span style="color: red">*</span>) adalah wajib untuk di isi. <strong>{{messages}}</strong>
    </div>
    <center>
      <pulse-loader style="margin: 15px" :loading="loading" color="#696969" size="10px"></pulse-loader>
    </center>
    <input type="checkbox" id="checkbox" style="margin-left: 10px" v-model="checkboxAyah">
    <label for="checkbox">Tidak Memiliki Ayah</label>
    <form class="form-horizontal form-space" onsubmit="return false">
      <div v-show="isExist('NM_BPK') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('nama_lengkap_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Nama Lengkap Ayah</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nama_lengkap_ayah"
            placeholder="Nama Lengkap Ayah"
            class="form-control"
            maxlength="32"
            v-model="model.nama_lengkap_ayah"
            v-validate="isExist('NM_BPK') && !checkboxAyah ? 'required' : ''"
          >
          <span v-show="errors.has('nama_lengkap_ayah')" class="error-label">Isi Nama Lengkap Ayah</span>
        </div>
      </div>
      <div v-show="isExist('STATUS_BPK') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('status_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Status Ayah</label>
        <div class="col-md-4">
          <select
            type="text"
            name="status_ayah"
            class="form-control"
            v-model="model.status_ayah"
            v-validate="isExist('STATUS_BPK')&& !checkboxAyah ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Status</option>
            <option v-for="status in options.status" :key="status.id_status" :value="status.id_status">
              {{ status.nama_status }}
            </option>
          </select>
          <span v-show="errors.has('status_ayah')" class="error-label">Pilih Status Ayah</span>
        </div>
      </div>
      <div v-show="isExist('TPT_LAHIR') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('tempat_lahir_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Tempat Lahir Ayah</label>
        <div class="col-md-6">
          <input
            type="text"
            name="tempat_lahir_ayah"
            placeholder="Tempat Lahir Ayah"
            class="form-control"
            maxlength="25"
            v-model="model.tempat_lahir_ayah"
            v-validate="isExist('TPT_LAHIR')&& !checkboxAyah ? 'required' : ''"
          >
          <span v-show="errors.has('tempat_lahir_ayah')" class="error-label">Isi Tempat Lahir Ayah</span>
        </div>
      </div>
      <div v-if="isExist('TGL_LAHIR') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('tanggal_lahir_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Tanggal Lahir</label>
        <div class="col-md-4">
          <datetimepicker name="tanggal_lahir_ayah"
            format="YYYY/MM/DD"
            :value="this.model.tanggal_lahir_ayah"
            placeholder="Tanggal Lahir"
            v-validate="isExist('TGL_LAHIR') && !checkboxAyah ? 'required' : ''"
            data-vv-validate-on="blur"
            @update-date="updateTglLahir">
          </datetimepicker>
          <span v-show="errors.has('tanggal_lahir_ayah')" class="error-label">Isi Tanggal Lahir</span>
        </div>
      </div>
      <div v-show="isExist('AGAMA') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('id_agama_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Agama</label>
        <div class="col-md-4">
          <select
            type="text"
            name="id_agama_ayah"
            class="form-control"
            v-model="model.id_agama_ayah"
            v-validate="isExist('AGAMA') && !checkboxAyah ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Agama</option>
            <option v-for="agama in options.agama" :key="agama.id" :value="agama.id_agama">
              {{ agama.nama_agama }}
            </option>
          </select>
          <span v-show="errors.has('id_agama_ayah')" class="error-label">Pilih Agama</span>
        </div>
      </div>
      <div v-show="isExist('PEND_BPK') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('id_jenjang_pendidikan_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Pendidikan</label>
        <div class="col-md-4">
          <select
            type="text"
            name="id_jenjang_pendidikan_ayah"
            class="form-control"
            v-model="model.id_jenjang_pendidikan_ayah"
            v-validate="isExist('PEND_BPK') && !checkboxAyah ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Pendidikan</option>
            <option v-for="jenjang in options.jenjang" :key="jenjang.id" :value="jenjang.id_jenjang">
              {{ jenjang.nama_jenjang }}
            </option>
          </select>
          <span v-show="errors.has('id_jenjang_pendidikan_ayah')" class="error-label">Pilih Pendidikan</span>
        </div>
      </div>
      <div v-show="isExist('PKJ_BPK') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('pekerjaan_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Pekerjaan Ayah</label>
        <div class="col-md-4">
          <select
            type="text"
            name="pekerjaan_ayah"
            class="form-control"
            v-model="model.pekerjaan_ayah"
            v-validate="isExist('PKJ_BPK') && !checkboxAyah ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Pekerjaan Ayah</option>
            <option v-for="pekerjaan in options.pekerjaan" :key="pekerjaan.id" :value="pekerjaan.id_pekerjaan">
              {{ pekerjaan.nama_pekerjaan }}
            </option>
          </select>
          <span v-show="errors.has('pekerjaan_ayah')" class="error-label">Pilih Pekerjaan Ayah</span>
        </div>
      </div>
      <div v-show="isExist('NEGARA') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('id_negara_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Negara Asal</label>
        <div class="col-md-4">
          <select
            type="text"
            name="id_negara_ayah"
            class="form-control"
            v-model="model.id_negara_ayah"
            v-validate="isExist('NEGARA') && !checkboxAyah ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Negara Asal</option>
            <option v-for="negara in options.negara" :key="negara.id" :value="negara.kode_negara">
              {{ negara.nama_negara }}
            </option>
          </select>
          <span v-show="errors.has('id_negara_ayah')" class="error-label">Pilih Negara Asal</span>
        </div>
      </div>
      <div v-show="isExist('PROVINSI') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('prop_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Provinsi</label>
        <div class="col-md-4">
          <select
            type="text"
            name="prop_ayah"
            class="form-control"
            v-model="model.prop_ayah"
            v-validate="isExist('PROVINSI') && !checkboxAyah ? 'required' : ''"
            v-on:change="() => onChangeProvinsi(true)"
          >
            <option value="null" hidden>Pilih Provinsi</option>
            <option v-for="provinsi in options.provinsi" :key="provinsi.id" :value="provinsi.kode_provinsi">
              {{ provinsi.nama_provinsi }}
            </option>
          </select>
          <span v-show="errors.has('prop_ayah')" class="error-label">Pilih Provinsi</span>
        </div>
      </div>
      <div v-show="isExist('KABUPATEN') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('kab_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Kabupaten</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kab_ayah"
            class="form-control"
            v-model="model.kab_ayah"
            v-validate="isExist('KABUPATEN') && !checkboxAyah ? 'required' : ''"
            v-on:change="() => onChangeKabupaten(true)"
          >
            <option value="null" hidden>Pilih Kabupaten</option>
            <option v-for="kabupaten in options.kabupaten" :key="kabupaten.id" :value="kabupaten.kode_kabupaten">
              {{ kabupaten.nama_kabupaten }}
            </option>
          </select>
          <span v-show="errors.has('kab_ayah')" class="error-label">Pilih Kabupaten</span>
          <pulse-loader style="margin: 15px" :loading="loadingKabupaten" color="#696969" size="10px"></pulse-loader>
        </div>
      </div>
      <div v-show="isExist('KECAMATAN') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('kec_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Kecamatan</label>
        <div class="col-md-4">
          <select
            type="text"
            name="kec_ayah"
            class="form-control"
            v-model="model.kec_ayah"
            v-validate="isExist('KECAMATAN') && !checkboxAyah ? 'required' : ''"
          >
            <option value="null" hidden>Pilih Kecamatan</option>
            <option v-for="kecamatan in options.kecamatan" :key="kecamatan.id" :value="kecamatan.kode_kecamatan">
              {{ kecamatan.nama_kecamatan }}
            </option>
          </select>
          <span v-show="errors.has('kec_ayah')" class="error-label">Pilih Kecamatan</span>
          <pulse-loader style="margin: 15px" :loading="loadingKecamatan" color="#696969" size="10px"></pulse-loader>
        </div>
      </div>
      <div v-show="isExist('KELURAHAN') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('desa_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Kelurahan</label>
        <div class="col-md-6">
          <input
            type="text"
            name="desa_ayah"
            placeholder="Kelurahan"
            class="form-control"
            maxlength="25"
            v-model="model.desa_ayah"
            v-validate="isExist('KELURAHAN') && !checkboxAyah ? 'required' : ''"
          >
          <span v-show="errors.has('desa_ayah')" class="error-label">Isi Kelurahan</span>
        </div>
      </div>
      <div v-show="isExist('RW') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('rw_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>RW</label>
        <div class="col-md-6">
          <input
            type="text"
            name="rw_ayah"
            placeholder="RW"
            class="form-control"
            maxlength="25"
            v-model="model.rw_ayah"
            v-validate="isExist('RW') && !checkboxAyah ? 'required' : ''"
          >
          <span v-show="errors.has('rw_ayah')" class="error-label">Isi RW</span>
        </div>
      </div>
      <div v-show="isExist('RT') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('rt_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>RT</label>
        <div class="col-md-6">
          <input
            type="text"
            name="rt_ayah"
            placeholder="RT"
            class="form-control"
            maxlength="25"
            v-model="model.rt_ayah"
            v-validate="isExist('RT') && !checkboxAyah ? 'required' : ''"
          >
          <span v-show="errors.has('rt_ayah')" class="error-label">Isi RT</span>
        </div>
      </div>
      <div v-show="isExist('ALAMAT_RUMAH') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('alamat_lengkap_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Alamat Rumah Ayah</label>
        <div class="col-md-6">
          <input
            type="text"
            name="alamat_lengkap_ayah"
            placeholder="Alamat Rumah Ayah"
            class="form-control"
            maxlength="25"
            v-model="model.alamat_lengkap_ayah"
            v-validate="isExist('ALAMAT_RUMAH') && !checkboxAyah ? 'required' : ''"
          >
          <span v-show="errors.has('alamat_lengkap_ayah')" class="error-label">Isi Alamat Rumah Ayah</span>
        </div>
      </div>
      <div v-show="isExist('KODE_POS') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('kode_pos_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Kode Pos</label>
        <div class="col-md-6">
          <input
            type="text"
            name="kode_pos_ayah"
            placeholder="Kode Pos"
            class="form-control"
            maxlength="25"
            v-model="model.kode_pos_ayah"
            v-validate="isExist('KODE_POS') && !checkboxAyah ? 'required' : ''"
          >
          <span v-show="errors.has('kode_pos_ayah')" class="error-label">Isi Kode Pos</span>
        </div>
      </div>
      <div v-show="isExist('TELP') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('telp_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Nomor Telepon</label>
        <div class="col-md-6">
          <input
            type="text"
            name="telp_ayah"
            placeholder="Nomor Telepon"
            class="form-control"
            maxlength="15"
            v-model="model.telp_ayah"
            v-validate="isExist('TELP') && !checkboxAyah ? 'required' : ''"
          >
          <span v-show="errors.has('telp_ayah')" class="error-label">Isi Nomor Telepon</span>
        </div>
      </div>
      <div v-show="isExist('HP') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('nohp_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>Nomor HP</label>
        <div class="col-md-6">
          <input
            type="text"
            name="nohp_ayah"
            placeholder="Nomor HP"
            class="form-control"
            maxlength="15"
            v-model="model.nohp_ayah"
            v-validate="isExist('HP') && !checkboxAyah ? 'required' : ''"
          >
          <span v-show="errors.has('nohp_ayah')" class="error-label">Isi Nomor HP</span>
        </div>
      </div>
      <div v-show="isExist('EMAIL') && !checkboxAyah" :class="{'form-group': true, 'has-error': errors.has('email_ayah')}">
        <label class="col-md-3"><span class="required-label">*</span>E-mail</label>
        <div class="col-md-6">
          <input
            type="text"
            name="email_ayah"
            placeholder="E-mail"
            class="form-control"
            maxlength="100"
            v-model="model.email_ayah"
            v-validate="isExist('EMAIL') && !checkboxAyah ? 'required|email' : 'email'"
          >
          <span v-show="errors.has('email_ayah')" class="error-label">Isi E-mail</span>
        </div>
      </div>
      <center>
        <pulse-loader style="margin: 15px" :loading="sending" color="#696969" size="10px"></pulse-loader>
      </center>
    </form>
  </div>
</template>

<script>
import api from '@/api'
import DateTimePicker from '@/components/DateTimePicker'
import kabupaten from '@/helper/data-master/kabupaten'
import kecamatan from '@/helper/data-master/kecamatan'
import Options from '@/helper/options'

export default {
  data () {
    return {
      init: false,
      loading: false,
      loadingKabupaten: false,
      loadingKecamatan: false,
      sending: false,
      checkboxAyah: false,
      model: {
        nama_lengkap_ayah: null,
        status_ayah: null,
        tempat_lahir_ayah: null,
        tanggal_lahir_ayah: null,
        id_agama_ayah: null,
        id_jenjang_pendidikan_ayah: null,
        pekerjaan_ayah: null,
        alamat_lengkap_ayah: null,
        rt_ayah: null,
        rw_ayah: null,
        desa_ayah: null,
        prop_ayah: null,
        kab_ayah: null,
        kec_ayah: null,
        id_negara_ayah: null,
        kode_pos_ayah: null,
        telp_ayah: null,
        nohp_ayah: null,
        email_ayah: null
      },
      savedModel: null,
      options: {
        kecamatan: [],
        kabupaten: [],
        provinsi: [],
        negara: [],
        agama: [],
        jenjang: [],
        status: [],
        pekerjaan: []
      }
    }
  },
  components: {
    'datetimepicker': DateTimePicker
  },
  computed: {
    nomorPendaftar () {
      return this.$store.getters.getAuthData.data.mhs_jalur.nomor_pendaftar
    },
    messages () {
      let message = ''
      this.$store.getters.getMessages(5).forEach(item => {
        message = message + ' ' + item.note + '.'
      })
      return message
    }
  },
  methods: {
    validate () {
      return new Promise((resolve, reject) => {
        this.validateForm()
          .then(valid => {
            this.sendData()
              .then(response => {
                resolve(true)
              })
              .catch(e => {
                e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan', 'error')
                scroll(0, 0)
                resolve(false)
              })
          })
          .catch(e => {
            this.flash(e.message, 'error')
            scroll(0, 0)
            resolve(false)
          })
      })
    },
    validateForm () {
      return new Promise((resolve, reject) => {
        this.$validator.validateAll()
          .then(valid => {
            if (valid) {
              resolve(true)
            } else {
              reject({message: 'isian belum lengkap'})
            }
          })
      })
    },
    isExist (name) {
      return this.$store.getters.formIsExist(name, 5)
    },
    updateTglLahir (date) {
      this.model.tanggal_lahir_ayah = date
    },
    async initData () {
      if (!this.init) {
        this.isExist('PROVINSI') ? this.options.provinsi = await Options.getOptionsProvinsi() : false
        this.isExist('NEGARA') ? this.options.negara = await Options.getOptionsNegara() : false
        this.isExist('AGAMA') ? this.options.agama = await Options.getOptionsAgama() : false
        this.isExist('PEND_BPK') ? this.options.jenjang = await Options.getOptionsJenjang() : false
        this.isExist('PKJ_BPK') ? this.options.pekerjaan = await Options.getOptionsPekerjaan() : false
        this.isExist('STATUS_BPK') ? this.options.status = await Options.getOptionsStatus() : false
        this.getData()
        this.init = true
      }
    },
    getData () {
      this.loading = true
      api.get('/v1/data_orang_tua/' + this.nomorPendaftar)
        .then(response => {
          let responseData = response.data
          if (responseData.success) {
            this.model = responseData.data
            this.model.prop_ayah ? this.onChangeProvinsi(false) : false
            this.model.kab_ayah ? this.onChangeKabupaten(false) : false
            this.loading = false
          }
        })
        .catch(e => {
          this.loading = false
        })
    },
    sendData () {
      return new Promise((resolve, reject) => {
        this.sending = true
        if (process.env.NODE_ENV !== 'test') {
          const model = JSON.stringify(this.model)
          if (model !== this.savedModel) {
            api.post('/v2/data_orang_tua/', {
              nomor_pendaftar: this.nomorPendaftar,
              ...this.model
            })
              .then(response => {
                this.sending = false
                this.savedModel = model
                resolve(response.data)
              })
              .catch(e => {
                this.sending = false
                reject(e.response)
              })
          } else {
            this.sending = false
            resolve(true)
          }
        } else {
          this.sending = false
          resolve(true)
        }
      })
    },
    async onChangeProvinsi (makenull) {
      this.loadingKabupaten = true
      try {
        this.options.kabupaten = await kabupaten.getByProvinsi(this.model.prop_ayah)
        if (makenull) {
          this.model.kab_ayah = null
          this.model.kec_ayah = null
        }
        this.loadingKabupaten = false
      } catch (e) {
        this.loadingKabupaten = false
        e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan saat mengambil data provinsi', 'error')
        scroll(0, 0)
      }
    },
    async onChangeKabupaten (makenull) {
      this.loadingKecamatan = true
      try {
        this.options.kecamatan = await kecamatan.getByKabupaten(this.model.kab_ayah)
        makenull ? this.model.kec_ayah = null : false
        this.loadingKecamatan = false
      } catch (e) {
        this.loadingKecamatan = false
        e.data ? this.flash(e.data.message, 'error') : this.flash('maaf terjadi kesalahan saat mengambil data kecamatan', 'error')
        scroll(0, 0)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/page/register/DataBapak.vue